
<mat-card class="mat-elevation-z8">
        <button mat-raised-button type="button" (click)="dialogRef.close('cancel')"  color="accent" style="margin-right: 30px;">Cancel</button>
           
        <button mat-button type="button"  (click)="dialogRef.close('delete')" color="warn">Delete</button>
</mat-card>